import environment from '../../environment/environment';

const globalName = 'gtag';

// Keeping the API/params consistent, we still provide isLast, even
// though it is not used for the google-analytics setup, thus eslint-disable
// eslint-disable-next-line no-unused-vars
function initialize(trackerConfig, count, isLast = true) {
  const env = environment.get();
  const trackerEndpoint = (trackerConfig.url)
    ? `${trackerConfig.url}?id=${trackerConfig.trackerId}`
    : `https://www.googletagmanager.com/gtag/js?id=${trackerConfig.trackerId}`;

  // load the 3rdparty-script only once, before setting up the first instance
  if (count === 0) {
    /* eslint-disable */
    (function() {
      var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
      g.async=true; g.defer=true; g.src=trackerEndpoint;
      s.parentNode.insertBefore(g,s);
    })();
    /* eslint-enable */
  }

  // for all trackers, add them to the ga-object
  window.dataLayer = window.dataLayer || [];
  /* eslint-disable-next-line prefer-rest-params, func-names */
  window[globalName] = function () { window.dataLayer.push(arguments); };
  window[globalName]('js', new Date());

  // if debugging is actiavted for this environment, activate
  // debugging for ga4 as well, by sending config
  if (env.logging && env.logging.debug === true) {
    window[globalName]('config', trackerConfig.trackerId, {
      send_page_view: false,
      debug_mode: true,
    });
  } else {
    window[globalName]('config', trackerConfig.trackerId, { send_page_view: false });
  }

  return {
    set(param, value) {
      const obj = {}; obj[param] = value;
      window[globalName]('config', trackerConfig.trackerId, obj);
    },

    setDimension(id, value) {
      // dimensions work differently for ga4: you can build them
      // via any custom parameters send with 'event'. thus when this
      // function is called, we add id-value pair to every track-event
      // function call, so that the values are always send too
      const obj = {}; obj[id] = value;
      window.ga4Dimensions = window.ga4Dimensions || [];
      window.ga4Dimensions.push(obj);
    },

    trackEvent(category, action, options) {
      // category is now a custom parameter, and we include all dimensions
      const categoryObject = (category !== false) ? { event_category: category } : {};
      const dimensions = window.ga4Dimensions || {};
      const customParams = { ...categoryObject, ...dimensions };
      customParams.event_origin = window.location.href;
      customParams.page_location = window.location.href;

      Object.keys(options).forEach((key) => {
        // note: ga4 does not support the concept of nonInteraction/transport
        // anymore so we omit those to keys, if they are sent anywhere
        const paramKey = `event_${key}`;
        const val = options[key];
        if (key !== 'nonInteraction' && key !== 'transport') {
          customParams[paramKey] = val;
        }
        // labels are cut of at 100 chars. make sure to cut the string
        // of from the beginning (often containing https://www.ag.ch/)
        if (key === 'label' && val && val.length > 100) {
          const label = val.trim();
          const startTruncatedLabel = label.substring(label.length - 100);
          customParams[paramKey] = startTruncatedLabel;
        }
      });

      window[globalName]('event', action, customParams);
    },

    trackPageView() {
      window[globalName]('event', 'page_view', {
        page_title: document.title,
        page_location: window.location.href,
      });
    },
  };
}

export default {
  initialize,
};
